module.exports = __webpack_public_path__ + "img/VA.8ba92781.png";